'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MoonIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MoonIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.9210795,16.0557083 C18.806544,15.8557291 18.5888638,15.7466581 18.3681042,15.778451 C15.7143549,16.1614343 13.1464699,14.8027828 11.8279514,12.4996619 C10.4714937,10.1303294 10.5992437,7.15643277 12.1533805,4.92327491 C12.2845089,4.73479995 12.2953316,4.48267679 12.180826,4.2827289 C12.0663204,4.082781 11.8486103,3.97361621 11.6278806,4.00547157 C10.6028014,4.15336924 9.62953379,4.51221881 8.7351046,5.07207916 C5.10013507,7.34753369 3.91319343,12.2909608 6.08927802,16.0918777 C8.27199974,19.9044239 12.9936064,21.1335595 16.6280677,18.8585113 C17.5224371,18.2986822 18.2846616,17.571167 18.8935743,16.6962543 C19.0247325,16.5078419 19.0355552,16.2557187 18.9210795,16.0557083 Z' })
  );
}